import type { GetCheckInStatusQuery } from '@eti/schema-types';

export type CheckInStatusType = GetCheckInStatusQuery['checkInStatus'];
export type CheckInLegsType = NonNullable<CheckInStatusType>['legs'];
export type CheckInLegType = NonNullable<CheckInLegsType>[number];
export type CheckInPassengersType = NonNullable<CheckInStatusType>['passengers'];
export type CheckInPassengerType = NonNullable<CheckInPassengersType>[number];

export const CheckInStatusInView = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
} as const;
export type CheckInStatusInViewType =
  (typeof CheckInStatusInView)[keyof typeof CheckInStatusInView];
